import { Chip } from "@mui/material";
import useColors from "../../../../../../api/hooks/useColors";
import iconMapping from "../../../../../../icons/IconMapping";

export default function ImpactChip({
  numberOfEntities,
  iconName = "Inventory",
}) {
  const colors = useColors();
  const Icon = iconMapping[iconName];
  return (
    <Chip
      label={numberOfEntities + " Entities"}
      icon={<Icon style={{ color: colors.text_primary, width: "20px" }} />}
      style={{
        background: colors.entity_chip_enabled_fill,
        borderRadius: "8px",
        fontSize: "12px",
        color: colors.text_primary,
        boxShadow: colors.entity_chip_inventory_shadow,
        height: "24px",
        paddingLeft: "4px",
        cursor: "default",
        userSelect: "none",
      }}
    />
  );
}
